import styled from '@emotion/styled';
import { NextPage } from 'next';
import Head from 'next/head';
import { useIsMobile } from '@hooks/responsive/useIsMobile';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

// components
import DefaultLayout from '@components/_templates/DefaultLayout';
import Title from '@components/_atoms/Title';
import Typography from '@components/_atoms/Typography';
import withAuth from '@components/hocs/withAuth';
import PushContent from '@components/_templates/push/PushContent';

// constants
import { MOBILE_MODE, TABLET_MODE } from '@constants/size';
import { TypoVariant } from '@constants/atoms';
import { gray } from '@styles/Colors';
import { useTranslation } from 'next-i18next';

const PushWrapper = styled.div`
  width: 100%;
  max-width: 528px;
  padding: 110px 0;
  margin: 0 auto;

  @media ${TABLET_MODE} {
    max-width: 768px;
    padding: 110px 40px;
  }

  @media ${MOBILE_MODE} {
    max-width: 320px;
    padding: 104px 0;
  }
`;

const TitleWrapper = styled.div`
  margin-bottom: 8px;
`;

const SubTitleWrapper = styled.div`
  margin-bottom: 80px;
  text-align: center;

  @media ${MOBILE_MODE} {
    margin-bottom: 40px;
  }
`;

const Push: NextPage = () => {
  const { t } = useTranslation('user');
  const isMobile = useIsMobile();

  return (
    <>
      <Head>
        <title>{t('push.meta-title')}</title>
        <meta name="title" content={t('push.meta-title')} />
      </Head>
      <DefaultLayout>
        <PushWrapper>
          <TitleWrapper>
            <Title content={t('push.title')} />
          </TitleWrapper>
          <SubTitleWrapper>
            <Typography variant={isMobile ? TypoVariant.B3 : TypoVariant.B4} color={gray.gray7}>
              {t('push.subTitle')}
            </Typography>
          </SubTitleWrapper>
          {/* Push Content */}
          <PushContent />
          {/* Push Content end */}
        </PushWrapper>
      </DefaultLayout>
    </>
  );
};

export const getStaticProps = async ({ locale }: { locale: any }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['user', 'common', 'component'])),
  },
});

export default withAuth(Push);
